/* ==========================================================================
   About / company narrative.
   Source: Bethel Content1.docx — used verbatim where the client wrote it.
   ========================================================================== */

export const philosophy = {
  title: 'Our Philosophy',
  statement:
    'Our philosophy is to provide business value through IT portfolio management by going above and beyond client expectation with integrity, innovation and excellence.',
};

export const story = {
  title: 'Our Story',
  body: [
    'Bethel Innovations LLC is a small business committed to providing IT consulting services in application development, IT service management, and strategic and real time cybersecurity support — creating innovative and flexible methods that prioritize excellence, efficiency and simplicity.',
  ],
};

export const whatWeDo = {
  title: 'What We Do',
  body: [
    'We provide enterprise IT services and strategic consulting technology services, thought leadership and business metric optimization to government, government contractors and nonprofit organizations.',
    'We support application integration, testing, and production deployment activities for application development, infrastructure engineering and integration of IRS applications and portal environments.',
    'We manage successful mapping of complex program and project security requirements, functionalities, and capabilities to NIST 800-53 security controls, FISMA, OMB, and US-CERT to ensure program and project compliance with FedRAMP cloud security standards, policies, and procedures.',
    'We provide the very best in IT Governance, IT Service Management, Cybersecurity, Information Assurance, Change and Configuration Management, Development and Operations (DevOps), and Continuous Integration and Continuous Improvement (CI/CD). We have earned the trust of our customers through sustained superior performance while supporting and aligning technology with their business and mission objectives.',
  ],
};

/* Full founder biography — the previous site compressed all four paragraphs
   into one and dropped the closing statement entirely. Restored in full. */
export const founder = {
  name: 'Tobi Oladipo',
  role: 'Founder & Principal Consultant',

  /* TODO(client): supply a professional headshot — Bethel Content1.docx asks
     for "a professional picture of yourself" and none was provided.

     The previous site used assets/img/home-about.png here with the alt text
     "Tobi Oladipo - Founder and CEO". That file is a stock cartoon
     illustration, not a photograph of anyone. Presenting it as a named
     person's likeness is inaccurate, and on a site where leadership
     credentials are the product it is a real credibility risk. Until a real
     headshot arrives the site renders a designed monogram instead. */
  photo: null,
  photoAlt: 'Tobi Oladipo, Founder and Principal Consultant of Bethel Innovations',
  initials: 'TO',
  summary:
    'A cybersecurity and change management industry expert, principal consultant and IT senior manager with proven expertise in application security, architecture and engineering.',
  bio: [
    'I am a Cybersecurity and Change Management industry expert, a principal consultant and IT senior manager with proven expertise in application security, architecture and engineering, utilizing eminent skills in systems integration, infrastructure support, cloud security, IT service management, program and project management to provide business value through IT.',
    'I have led and continue to support the cybersecurity delivery arm of multiple projects at the Treasury Department, providing oversight of security deliverables and successfully supporting application and infrastructure delivery of high visibility projects and sensitive engagements.',
    'As lead solution architect, I have provided strategic and full life cycle management support for the modernization of IRS tax system infrastructure portals, network, virtualization, server management, and data integration by leveraging existing platforms and technology.',
    'I am the founder and Principal Consultant of Bethel Innovations LLC and I see my role as a steward and servant leader.',
  ],
  expertise: [
    'Application security, architecture and engineering',
    'Systems integration and infrastructure support',
    'Cloud security',
    'IT service management',
    'Program and project management',
  ],
};
